import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { type WebsiteModuleSpecsFragment } from '../../../../../api/fragments/WebsiteModuleSpecs';
import {
    CreateWebsiteModuleDocument,
    type CreateWebsiteModuleMutation,
    type CreateWebsiteModuleMutationVariables,
} from '../../../../../api/mutations/createWebsiteModule';
import { type CreateWebsiteModulePayload } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import WebsiteModulePage, { type WebsiteModulePageProps } from '../../WebsiteModulePage';
import { type ModuleImplementation } from './types';

type WebsiteModuleImplementation = ModuleImplementation<WebsiteModuleSpecsFragment, CreateWebsiteModulePayload>;

const validator = validators.requiredNonEmptyString('displayName');

const colSpan = { md: 12, xs: 24 };
const Form: WebsiteModuleImplementation['FormComponent'] = () => {
    const { t } = useTranslation('moduleDetails');

    return (
        <Row gutter={10}>
            <Col {...colSpan}>
                <InputField
                    {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                    name="displayName"
                    required
                />
            </Col>
        </Row>
    );
};

const implementation: WebsiteModuleImplementation = {
    PageComponent: (props: WebsiteModulePageProps) => <WebsiteModulePage {...props} />,
    getTitle: t => t('moduleDetails:implementations.WebsiteModule.className'),
    FormComponent: Form,
    getValidator: () => validator,
    create: async (apolloClient, companyId, { displayName }) =>
        apolloClient
            .mutate<CreateWebsiteModuleMutation, CreateWebsiteModuleMutationVariables>({
                mutation: CreateWebsiteModuleDocument,
                variables: { companyId, settings: { displayName } },
            })
            .then(({ data }) => data.module),
};

export default implementation;
